import { render, staticRenderFns } from "./ImportantMessagesModal.vue?vue&type=template&id=245048c6&"
import script from "./ImportantMessagesModal.vue?vue&type=script&lang=js&"
export * from "./ImportantMessagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports